@if (reservedDieForm) {
  <div [formGroup]="reservedDieForm">
    <!-- RSJ use -->
    <div class="row">
      <div class="col-12 col-lg-12">
        <p>
          <strong> Utilisation du RSJ </strong>
        </p>
      </div>
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap text-secondary">
      <div class="col-12 col-lg-5">
        <label class="float-start">Qualifier l'utilisation du RSJ</label>
      </div>
      <div class="col-12 col-lg-5">
        <select class="form-select" formControlName="useTitleId">
          <option value=""></option>
          @for (useTitle of useTitles; track useTitle) {
            <option [ngValue]="useTitle.id">
              {{ useTitle.label }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 text-secondary col-12">
        <label>Commentaire utilisation du RSJ</label>
        <textarea class="form-control" formControlName="useTitleComment"></textarea>
      </div>
    </div>
    <!-- RSJ state -->
    <div class="row">
      <div class="col-12 col-lg-12">
        <p>
          <strong> État DIE </strong>
        </p>
      </div>
    </div>
    <div class="row mb-3 d-flex flex-row align-items-center flex-wrap text-secondary">
      <div class="col-12 col-lg-5">
        <label class="float-start">Information état DIE</label>
      </div>
      <div class="col-12 col-lg-5">
        <select class="form-select" formControlName="stateTitleId">
          <option value=""></option>
          @for (stateTitle of stateTitles; track stateTitle) {
            <option [ngValue]="stateTitle.id">
              {{ stateTitle.label }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="row">
      <div class="mb-3 text-secondary col-12">
        <label>Commentaire état</label>
        <textarea class="form-control" formControlName="stateTitleComment"></textarea>
      </div>
    </div>
  </div>
}
